// ABOUTME: Tells the modules that keep one person's work outside React — a message being written, messages on their
// ABOUTME: way — that another person signed in on the tab: a sign-in after an expired session does not reload it.

const listeners = new Set<() => void>()
let signedIn: string | null = null

/** Erase what belongs to the person signed in before; the returned function stops listening. */
export function onUserSwitch(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/**
 * The person now signed in (UserProvider, as `me` loads). Listeners hear only of a switch from one person to another:
 * the first sign-in of the page has nothing before it to erase.
 */
export function userSignedIn(userId: string): void {
  const before = signedIn
  signedIn = userId
  if (before !== null && before !== userId) listeners.forEach((listener) => listener())
}

/** Test seam: no one signed in yet. The listeners stay: modules subscribe once, as they load. */
export function resetUserSwitchForTests(): void {
  signedIn = null
}
